import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button,Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import SignalRService from 'src/controllers/SignalRService';
import DataGrid, { Paging, Column, Lookup, FilterRow , Pager} from 'devextreme-react/data-grid';

class MailHistory extends Component {

    constructor(props) {

        super(props)
        this.state = {
            mails: [],
            callTypes: [
                { id: true, name: "outgoing" },
                { id: false, name: "incoming" }
            ]
        }
        this.setMails = this.setMails.bind(this);
        SignalRService.registerMailsList(this.setMails);
        
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.show && this.props.mail !== null && (prevProps.mail === null || this.props.mail.id !== prevProps.mail.id)) {

            let mailId = !this.props.mail.outbound ? parseInt(this.props.mail.id) : null;
            let mailResponseId = this.props.mail.outbound ? parseInt(this.props.mail.id) : null;

            SignalRService.getMails({ Extension: this.props.extension, UserId: this.props.userId, MailId: mailId, MailResponseId: mailResponseId }, x => { });
        }
    }

    setMails = data => {

        if (data !== null && data.length > 0) {
            data.forEach(e => {
                e.date = new Date(e.date);
            });
            this.setState({
                mails: data
            });
        }

    }

    typeCell = dataCell => {
        return (<div className={`${!dataCell.value ? 'text-success' : 'text-primary'} text-center`}  >
            {
                (dataCell.value) &&
                <FontAwesomeIcon className='primary' size='2x' icon={duotone('arrow-up-right')} />
            }
            {
                (!dataCell.value) &&
                <FontAwesomeIcon className='success' size='2x' icon={duotone('arrow-down-left')} />
            }
        </div>
        )
    }

    interactionMailClick = (emailMessageNumber, inbox) => {

        var data = JSON.parse(localStorage.getItem("fc-logged"));
        var rcu = localStorage.getItem("faRCUser");
        var rcp = localStorage.getItem("faRCPwd");
        var roundcubeUrl = localStorage.getItem("faRC");
        var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_faagtinbox=1`;

        window.open(url);

    }

    viewChatCell = dataCell => {
        return (
            <Button variant="light-primary" size='sm'
                onClick={e => { console.log(dataCell); this.interactionMailClick(dataCell.data.messageNumber, dataCell.data.inbox) }}>
                <FontAwesomeIcon icon={duotone('eye')} /></Button>
        )
    }

    linkCell = dataCell => {
        return (
            <div className={`text-primary text-center m-3`}>
                {
                    (dataCell.value) &&
                    <FontAwesomeIcon className='primary' size='lg' icon={duotone('link')} />
                }
            </div>);
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} size="xlg" backdrop="static">
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("clock-rotate-left")} /> {this.props.t("emailthread")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <DataGrid
                            dataSource={this.state.mails}
                            keyExpr="mailId"
                            showBorders={true}
                            noDataText=""
                            rowAlternationEnabled={true}
                        >
                            <Column dataField="outbound" cssClass={"align-middle"} caption={this.props.t("type")} width={100} cellRender={this.typeCell}>
                                <Lookup className="field-customization"
                                    dataSource={this.state.callTypes}
                                    valueExpr="id"
                                    displayExpr={e => {
                                        return this.props.t(e.name);
                                    }}
                                /></Column>
                            <Column dataField="related" width={100} caption={this.props.t("related")} cellRender={this.linkCell} />
                            <Column dataField="agent" caption={this.props.t("agent")} />
                            <Column dataField="date" dataType="datetime" format='dd/MM/yyyy HH:mm:ss' caption={this.props.t("datetime")} sortOrder="desc" sortIndex={0} />
                            <Column dataField="from" caption={this.props.t("from")} />
                            <Column dataField="to" caption={this.props.t("to")} />
                            <Column dataField="subject" caption={this.props.t("subject")} />
                            <Column dataField="reference" caption={this.props.t("reference")} />
                            <FilterRow visible={true} applyFilter={"auto"} showOperationChooser={false} />
                            <Column dataField="chatGuid" caption={""} width={60} cellRender={this.viewChatCell} allowFiltering={false} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[5, 9, 12, 15]}
                                showInfo={true}
                                showNavigationButtons={true}
                                infoText={this.props.t("pager")}
                            />
                            <Paging defaultPageSize={12} />
                        </DataGrid>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId
    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(MailHistory);